import Api from '@/services/Api'

export default {
  // Método que llama a la url para crear un chat
  getCie10Groups () {
   return Api().get("/grupos-cie-10-s/");
  },
  getCie10SubGroups (params) {
    return Api().get("/grupos-sub-cie-by-idgrupo/"+params);
  },
  getCie10SubCategoryGroups (params) {
    return Api().get("/grupos-sub-categoria-cie-by-idgruposub/"+params);
  },
  findCie10SubCategoryGroupsByDescripcion(params) {
    return Api().get("/find-by-descripcion/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/Cie10Service.js